import script from "./featureHighlight.vue?vue&type=script&lang=js"
export * from "./featureHighlight.vue?vue&type=script&lang=js"

import "./featureHighlight.vue?vue&type=style&index=0&id=04a4465a&lang=scss"

const __exports__ = script;

export default __exports__